if (!customElements.get('lusso-store-carousel')) {
  customElements.define('lusso-store-carousel', class LussoStoreCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-store-viewport]');
      this.slides = [...this.querySelectorAll('[data-store-slide]')];
      this.previousButton = this.querySelector('[data-store-previous]');
      this.nextButton = this.querySelector('[data-store-next]');
      this.counter = this.querySelector('[data-store-current]');
      this.index = 0;
      this.timer = null;
      this.scrollRequest = null;
      this.interval = Number(this.dataset.autoplay) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || this.slides.length < 2) return;

      this.handlePrevious = () => this.goTo(this.index - 1, true);
      this.handleNext = () => this.goTo(this.index + 1, true);
      this.handleScroll = () => {
        if (this.scrollRequest) cancelAnimationFrame(this.scrollRequest);
        this.scrollRequest = requestAnimationFrame(() => {
          this.scrollRequest = null;
          const nextIndex = Math.round(this.viewport.scrollLeft / Math.max(1, this.viewport.clientWidth));
          this.setIndex(nextIndex);
        });
      };
      this.handlePause = () => this.stopAutoplay();
      this.handleResume = () => this.startAutoplay();
      this.handleVisibility = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.addEventListener('pointerenter', this.handlePause);
      this.addEventListener('pointerleave', this.handleResume);
      this.addEventListener('focusin', this.handlePause);
      this.addEventListener('focusout', this.handleResume);
      this.addEventListener('touchstart', this.handlePause, { passive: true });
      this.addEventListener('touchend', this.handleResume, { passive: true });
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.setIndex(0);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.scrollRequest) cancelAnimationFrame(this.scrollRequest);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('pointerenter', this.handlePause);
      this.removeEventListener('pointerleave', this.handleResume);
      this.removeEventListener('focusin', this.handlePause);
      this.removeEventListener('focusout', this.handleResume);
      this.removeEventListener('touchstart', this.handlePause);
      this.removeEventListener('touchend', this.handleResume);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    setIndex(index) {
      this.index = Math.min(this.slides.length - 1, Math.max(0, index));
      if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
    }

    goTo(index, userInitiated = false) {
      const target = (index + this.slides.length) % this.slides.length;
      this.setIndex(target);
      this.viewport.scrollTo({ left: target * this.viewport.clientWidth, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      if (userInitiated) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (this.reducedMotion.matches || document.hidden || this.slides.length < 2 || this.matches(':hover') || this.matches(':focus-within')) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.goTo(this.index + 1), this.interval);
    }

    stopAutoplay() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  });
}
